import solwioLogo from "../Assets/images/SolwioLogo2.png";
import { PG_MERCHANT_API_BASE_URL, PG_MERCHANT_WS_BASE_URL } from "./env";

export const getServerEnvironment = (hostName) => {
  if (hostName === "login.godemo.in" || hostName === "localhost")
    return "develpmentSolwio";
  else if (hostName === "old.solwio.in") {
    return "productionSolwioOld";
  } else return "productionSolwio";
};

export function getCompleteDomain() {
  const { protocol, hostname, port } = window.location;
  return hostname;
}

export const config = (serverEnvironment) => {
  const logos = {
    productionSolwio: solwioLogo,
    develpmentSolwio: solwioLogo,
    productionSolwioOld: solwioLogo,
  };
  const bankDetails = {
    develpmentSolwio: {
      BName: "Solwio Solutions Private Limited",
      bankName: "IDFC Bank",
      branch: "Bhopal Kolar Road",
      Account: "10152683089",
      ifsc: "IDFB0041386",
    },

    productionSolwio: {
      BName: "ICEWEB TECHNOLOGY SOLUTIONS (OPC) PVT LTD",
      bankName: "IDFC FIRST BANK",
      branch: "SEAWOODS BRANCH",
      Account: "10151493000",
      ifsc: "IDFB0040158",
    },

    productionSolwioOld: {
      BName: "ICEWEB TECHNOLOGY SOLUTIONS (OPC) PVT LTD",
      bankName: "IDFC FIRST BANK",
      branch: "SEAWOODS BRANCH",
      Account: "10151493000",
      ifsc: "IDFB0040158",
    },
  };
  const Names = {
    develpmentSolwio: "Solwio",
    productionSolwio: "Solwio",
    productionSolwioOld: "Solwio",
  };

  const apiDocsUrl = {
    productionSolwio: {
      paymentIntegrationKitUrl: "https://pg.solwio.in/paymentrequest/seamless",
    },

    develpmentSolwio: {
      paymentIntegrationKitUrl: "https://pg.solwio.in/paymentrequest/seamless",
    },
    productionSolwioOld: {
      paymentIntegrationKitUrl: "https://pg.solwio.in/paymentrequest/seamless",
    },
  };
  // Hostname-based fallbacks, used only when no runtime value is injected via
  // window.__ENV__ (see utils/env.js + docker-entrypoint.sh). Backend is a
  // separate host from the frontend, so production points at its own domain.
  const Urls = {
    develpmentSolwio: "https://api.godemo.in/",
    productionSolwio: "https://merchant-panel-backend.patroni.site/",
    productionSolwioOld: `https://${window?.location?.hostname}/api/`,
  };
  const WSUrls = {
    develpmentSolwio: "https://api.godemo.in/TelegramBot/ws/",
    productionSolwio: "https://merchant-panel-backend.patroni.site/TelegramBot/ws/",
    productionSolwioOld: `https://${window?.location?.hostname}/TelegramBot/ws/`,
  };
  const logoPath = logos[serverEnvironment];
  const Name = Names[serverEnvironment];

  // Prefer runtime-injected values from window.__ENV__ (see utils/env.js and
  // docker-entrypoint.sh). Fall back to the hostname-based maps when the
  // corresponding PG_MERCHANT_* variable is not provided (e.g. plain local dev).
  const Url = PG_MERCHANT_API_BASE_URL || Urls[serverEnvironment];
  const WSUrl = PG_MERCHANT_WS_BASE_URL || WSUrls[serverEnvironment];
  const bankDeatails = bankDetails[serverEnvironment];
  const panelApiDocsUrl = apiDocsUrl[serverEnvironment];

  return {
    logoPath,
    Name,
    Url,
    WSUrl,
    bankDeatails,
    panelApiDocsUrl,
  };
};
